<template>
  <div class="flex min-h-screen flex-col">
    <a
      href="#main-content"
      class="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-brand-600 focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-white focus:shadow-lg"
    >
      {{ t('common.skip_to_content') }}
    </a>
    <AppHeader />
    <main id="main-content" class="flex-1">
      <router-view />
    </main>
    <AppFooter />
    <CookieConsent />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import AppHeader from '@/components/layout/AppHeader.vue';
import AppFooter from '@/components/layout/AppFooter.vue';
import CookieConsent from '@/components/CookieConsent.vue';

const { t } = useI18n();
</script>
